import { enableProdMode, importProvidersFrom } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_SELECT_CONFIG, MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter } from '@ngxmc/datetime-picker';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { FileUploadModule } from 'ng2-file-upload';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';
import { CustomDatetimeAdapter } from './app/core/custom-datetime-adapter';
import { CustomHttpInterceptor } from './app/core/custom-http-Interceptor';
import { DownloadHelper } from './app/helpers/download-helper';
import { environment } from './environments/environment';
import { AppRoutingModule } from './modules/app-routing.module';
import { MY_FORMATS_DATE, MY_FORMATS_DATETIME } from './modules/date-formatting.module';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            MatFormFieldModule,
            MatCardModule,
            MatInputModule,
            MatButtonModule,
            MatBottomSheetModule,
            MatMenuModule,
            MatTableModule,
            MatSortModule,
            MatTabsModule,
            MatCheckboxModule,
            MatRadioModule,
            MatBadgeModule,
            MatIconModule,
            MatDatepickerModule,
            MatSidenavModule,
            MatExpansionModule,
            MatDialogModule,
            MatSelectModule,
            MatSelectInfiniteScrollModule,
            MatTooltipModule,
            MatChipsModule,
            MatAutocompleteModule,
            MatToolbarModule,
            MatListModule,
            DragDropModule,
            FileUploadModule,
            AngularEditorModule,
            MatNativeDateModule,
            FontAwesomeModule,
            NgxSpinnerModule,
            NgApexchartsModule,
            MatSliderModule,
            MatSlideToggleModule,
            ToastrModule.forRoot({
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                preventDuplicates: true,
            }),
            AppRoutingModule,
            QuillModule.forRoot()
        ),
        { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { strict: true } },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_DATE },
        { provide: NGX_MAT_DATE_FORMATS, useValue: MY_FORMATS_DATETIME },

        { provide: NgxMatDateAdapter, useClass: CustomDatetimeAdapter },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto', appearance: 'fill' } },
        { provide: MAT_SELECT_CONFIG, useValue: { overlayPanelClass: 'expandable-overlay-panel' } },
        DownloadHelper,
        DatePipe,
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
    ],
}).catch((err) => console.error(err));
